import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

import type { CustomContentItem } from "@shared/types/CustomContent";
import type { PaidSponsorTag } from "@shared/types/PaidSponsorTag";

interface SponsoredProductPageEntityParams {
  id: number;
  custom_content_id: number;
  custom_content_type: string;
  contract_id: string;
  sponsors: PaidSponsorTag[];
  custom_content_items: CustomContentItem[];
  collection_segment_id: number;
}

export class SponsoredProductPageEntity extends BaseEntityClass {
  sponsored_product_page_id: number;
  custom_content_id: number;
  custom_content_type: string;
  contract_id: string;
  sponsors: PaidSponsorTag[];
  custom_content_items: CustomContentItem[];
  collection_segment_id: number;

  constructor(params: SponsoredProductPageEntityParams) {
    super();
    this.type = "sponsored_product_page";
    this.entity_version = 3;
    this.sponsored_product_page_id = params.id;
    this.custom_content_id = params.custom_content_id;
    this.custom_content_type = params.custom_content_type;
    this.contract_id = params.contract_id;
    this.sponsors = params.sponsors;
    this.custom_content_items = params.custom_content_items;
    this.collection_segment_id = params.collection_segment_id;
  }
}
